import { BaseModel } from "sjs-base-model";
import DipendenteSPTModel from "./DipendenteSPTModel";
import EsitoRichiestaModel from "./EsitoRichiestaModel";
import IstitutoFinanziarioModel from "./IstitutoFinanziarioModel";

export default class ResponseModel extends BaseModel {
    public readonly esitoRichiesta: EsitoRichiestaModel = new EsitoRichiestaModel({});
    public readonly istitutoFinanziario: IstitutoFinanziarioModel = new IstitutoFinanziarioModel({});
    public readonly dipendenteSPT: DipendenteSPTModel = new DipendenteSPTModel({});

    constructor(data: Partial<ResponseModel>) {
        super();

        this.update(data);
    }
}
